module.exports = __webpack_public_path__ + "static/img/dd-partner-06.c917d63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-06.jpg
// module id = s0na
// module chunks = 1